import {
  Box,
  FormControl,
  FormLabel,
  Input,
  FormHelperText,
  Textarea,
  Divider,
  HStack,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  Text,
} from '@chakra-ui/react';

import {
  DetailedTask,
  FormFieldTypes,
  FormFiled,
  TaskStatus,
} from '../../../models';
import { useTypedSelector } from '../../../hooks';

export const FormFelidWithAnswer = ({
  formField: {
    title,
    id,
    requiredForInitiation,
    type,
    description,
    options,
    whoCanAnswer,
  },
  taskData,
  onChangeAnswer,
}: {
  onChangeAnswer: (fieldId: number, answer: string) => void;
  formField: FormFiled;
  taskData?: DetailedTask;
}) => {
  const { userDetails } = useTypedSelector(state => state.auth);
  const isTeamTasks = location.pathname.includes('my-team');

  const isTaskNotCompleted =
    !taskData?.status ||
    [TaskStatus.InProgress, TaskStatus.Late].includes(taskData.status);

  const isUserCanAnswer =
    ((whoCanAnswer && whoCanAnswer[0] === 'all') ||
      whoCanAnswer?.includes(String(userDetails?.role.id))) &&
    taskData?.currentAssignees.some(
      assignee => assignee.id === userDetails?.id
    );

  const isFieldAnswered = taskData?.formFieldAnswers.find(
    ({ formFieldId }) => formFieldId === id
  )?.answer;

  return (
    <Box w="full">
      {/* {!isUserCanAnswer ? ( */}
      <FormControl isRequired={requiredForInitiation}>
        <FormLabel>{title}</FormLabel>

        {!isTeamTasks &&
        isTaskNotCompleted &&
        !isFieldAnswered &&
        isUserCanAnswer ? (
          <Box>
            {[
              FormFieldTypes.text,
              FormFieldTypes.number,
              FormFieldTypes.signature,
            ].includes(type) && (
              <Input
                w="full"
                type={type === FormFieldTypes.number ? 'number' : 'text'}
                onChange={e => onChangeAnswer(Number(id), e.target.value)}
              />
            )}

            {type === FormFieldTypes.longText && (
              <Textarea
                w="full"
                onChange={e => onChangeAnswer(Number(id), e.target.value)}
              />
            )}

            {type === FormFieldTypes.date && (
              <Input
                w="full"
                type="date"
                onChange={e => onChangeAnswer(Number(id), e.target.value)}
              />
            )}

            {type === FormFieldTypes.multipleSelection && (
              <CheckboxGroup
                colorScheme="orange"
                onChange={value => onChangeAnswer(Number(id), value.join(', '))}
              >
                <HStack>
                  {options?.map(option => (
                    <Checkbox key={option.title} value={option.title}>
                      {option.title}
                    </Checkbox>
                  ))}
                </HStack>
              </CheckboxGroup>
            )}

            {type === FormFieldTypes.singleSelection && (
              <RadioGroup
                colorScheme="orange"
                onChange={nextValue => onChangeAnswer(Number(id), nextValue)}
              >
                <HStack>
                  {options?.map(option => (
                    <Radio key={option.title} value={option.title}>
                      {option.title}
                    </Radio>
                  ))}
                </HStack>
              </RadioGroup>
            )}
          </Box>
        ) : (
          <>
            {!isFieldAnswered && title && (
              <Text fontFamily="mono" style={{ color: '#9D9D9D' }}>
                You dont have permission to answer this question
              </Text>
            )}
          </>
        )}

        {(!isTaskNotCompleted ||
          isTeamTasks ||
          isFieldAnswered ||
          !isUserCanAnswer) && (
          <Box>
            {taskData?.formFieldAnswers
              .find(field => field.formFieldId === id)
              ?.answer.split(',')
              .join('')}
          </Box>
        )}

        {type === FormFieldTypes.separator && <Divider borderColor="#9D9D9D" />}

        {description && <FormHelperText>{description}</FormHelperText>}
      </FormControl>
      {/* ) : (
        <>
          <Text fontFamily="mono" style={{ color: '#9D9D9D' }}>
            You dont have permission to answer this question
          </Text>
        </>
      )} */}
    </Box>
  );
};
